define('drops/multiSelect/dropDownMultiSelect',[
    'jquery',
    'underscore',
    'lq/style',
    './dropdownitem',
    'drops/modals',
    'lq/dropDownsListPositioning'
], function ($, _, Style, DropDownItem, modals, dropDownsListPositioning) {
    'use strict';

    var arrowDownKey = 40;
    var arrowUpKey = 38;

    var offsetToTheEdge = 10;
    var offsetFromInput = 4;
    var defMaxHeight = Number.MAX_SAFE_INTEGER;

    var DropDownMultiSelect = function (drop) {
        this.drop = drop;
        this.$el = $('<div />');
        this.$list = $('<div />');

        this.$placeholder = $('<div />')
            .addClass('drop-text-content multiselect-placeholder')
            .text(drop.data.placeholder || '')
        this.$el.prepend(this.$placeholder);
    };

    DropDownMultiSelect.prototype.render = function () {
        this.$el
            .addClass('multi-drop-down collapsed');

        this.$label = $('<div />')
            .addClass('multi-drop-down-label drop-text-content');

        var self = this;

        this.$buttonWrapper = $('<div/>')
            .addClass("multi-drop-down-button-wrapper");

        if (!this.drop.data.readOnly) {
            this.$button = $('<div />')
                .addClass('multi-drop-down-button')
                .attr('tabindex', this.drop.data.tabIndex)
                .on('keydown', function (e) {
                    if (e.which === arrowDownKey && !self.isOpen()) {
                        self.open();
                        e.preventDefault();
                    } else if (e.which === arrowUpKey && self.isOpen()) {
                        self.close();
                        e.preventDefault();
                    }
                });

            this.$el
                .on('click', function () {
                    if (self.isOpen())
                        self.close();
                    else
                        self.open();
                });
        }

        this.$button
            .appendTo(this.$buttonWrapper);

        this.$el
            .append(this.$label, this.$buttonWrapper)
            .appendTo(this.drop.$element);

        this.$list
            .hide()
            .addClass('multi-drop-down-list')
            .addClass('prevent-hover')
            .addClass('prevent-normal')
            .appendTo(this.drop.piping.$app);

        if (typeof this.drop.data.styles === 'string') {
            Style.renderStyles(this.drop, null, this.$list);
        }

        if (this.drop.data.gridStyleId)
            this.$list.addClass(this.getGridStyleClassName());

        this.onClicked = this.handleClickOnDocument.bind(this);
        this.onScrolled = this.scrolledInApp.bind(this);

        $(document).on('click', this.onClicked);
        this.drop.piping.$actionWrapper.on('scroll', this.onScrolled);
        this.togglePlaceholder(true);
        this.drop.subscribeEventHandler($(window), 'resize', _.debounce(this.renderDropdown.bind(this, true), 50));
    };

    DropDownMultiSelect.prototype.handleClickOnDocument = function (e) {
        if (!this.isOpen())
            return;

        var targetWasNotThisDrop = $(e.target).closest(this.drop.$element).length === 0;
        var targetWasNotThisList = $(e.target).closest(this.$list).length === 0;

        if (targetWasNotThisDrop && targetWasNotThisList)
            this.close();
    };

    DropDownMultiSelect.prototype.scrolledInApp = function() {
        this.$list.hide();
    };

    DropDownMultiSelect.prototype.getGridStyleClassName = function () {
        return Style.getClassNameFromStyleId('gridstyle-', this.drop.data.gridStyleId);
    };

    DropDownMultiSelect.prototype.isOpen = function () {
        return this.$list.is(':visible');
    };

    DropDownMultiSelect.prototype.open = function () {
        this.renderDropdown();
        this.$list.show();
    };

    DropDownMultiSelect.prototype.renderDropdown = function (isResizing) {
        if (isResizing && !this.$list.is(':visible'))
            return;
        this.$el
            .removeClass('collapsed')
            .addClass('expanded');

        var $parent = this.drop.$element;
        var $app = this.drop.piping.$app;
        var top = $parent.offset().top - $app.offset().top + $parent.outerHeight() + 4; // 4px offset
        var left = $parent.offset().left - $app.offset().left;

        var maxHeight = $app.height() - top;

        var borderWidthOfList = this.$list.outerWidth() - this.$list.innerWidth();
        this.$list
            .css({
                top: top,
                left: left,
                width: $parent.outerWidth() - borderWidthOfList,
                zIndex: modals.getZIndexForPopups()
            });

        dropDownsListPositioning.positionList(this.$list, this.drop.$element, offsetFromInput, offsetToTheEdge, defMaxHeight);
    };

    DropDownMultiSelect.prototype.close = function () {
        this.$el
            .removeClass('expanded')
            .addClass('collapsed');
        this.$list.hide();
        this.drop.triggerEventIfEnabled('collapsed');
    };

    DropDownMultiSelect.prototype.updateRequiredIndicator = function() {
        this.drop.updateRequiredIndicator();
    };

    DropDownMultiSelect.prototype.triggerEventIfEnabled = function (eventName, eventArg) {
        this.drop.triggerEventIfEnabled(eventName, eventArg);
    };

    DropDownMultiSelect.prototype.setItems = function (items, outputs) {
        var columns = _.keys(outputs);
        this.$list.empty();

        var self = this;

        if (this.drop.data.addAllOption) {
            var id = _.uniqueId('select_all_');
            var $allDiv = $('<div />')
                .addClass('all-option')
                .css({
                    display: 'flex',
                    flexFlow: 'row'
                })
                .append($('<label class="checkbox-wrapper" />')
                .css('padding', '1px')
                .append($('<input type="checkbox" id="' + id + '" />')
                    .addClass('userstyle-' + self.drop.data.styles)
                    .prop('checked', this.drop.data.selectAllByDefault)
                    .on('change', function () {
                        var $this = $(this);

                        if ($this.prop('checked'))
                            self.selectAll();
                        else
                            self.clear();

                        self.drop.triggerEventIfEnabled('changed');
                    }))
                    .append($('<div class="custom-icon" />').css("display", "none")))
                .append($('<label for="' + id + '" />').addClass('all-label').text(this.drop.data.allOptionLabel))
            this.$list.append($allDiv);

            if (typeof this.drop.data.styles !== 'string') {
                Style.renderStyles(this.drop, null, $allDiv, null, 'all');
            }
        }

        columns = _.difference(columns, _.union(this.drop.data.hiddenColumns, [ this.drop.data.idOutput ]));

        // using <table /> because we are reusing the Grid styles here
        var $table = $('<table />');

        if (columns.length > 1) {
            var $checkboxHeader = $('<th />')
                .addClass('checkbox-column')
                .addClass('gridHeader');

            var $headers = _.map(columns, function (column) {
                return $('<th />')
                    .addClass('gridHeader')
                    .text(column);
            });
            var $trh = $('<tr />')
                .addClass('tableHeader')
                .append($checkboxHeader)
                .append($headers);
            $table.append($trh);

            if (typeof this.drop.data.styles !== 'string') {
                Style.renderStyles(this.drop, null, $trh, null, 'header');
            }
        }

        var textOutput = columns[0];
        var idOutput = this.drop.data.idOutput;

        this.rows = _.map(items, function (item) {
            var row = new DropDownItem(self, item[idOutput], item[textOutput], self.drop.selectAllByDefault);

            row.addExtraColumns(_.map(columns, function (column) {
                return { content: item[column], type: outputs[column], columnName: column };
            }));

            return row;
        });

        if (this.drop.data.selectAllByDefault) {
            _.each(this.rows, function (row) {
                row.check();
            });
        }

        var $rows = _.pluck(this.rows, '$element');
        $table.append($rows);

        this.$list.append($table);

        this.updateUi();
    };

    DropDownMultiSelect.prototype.clear = function () {
        var self = this;
        _.each(this.rows, function(row) {
            if(row.checked) {
                row.uncheck();
                self.drop.triggerEventIfEnabled('itemDeselected', row.id);
            }
        });
    };

    DropDownMultiSelect.prototype.selectAll = function () {
        var self = this;
        _.each(this.rows, function (row) {
            if(!row.checked) {
                row.check();
                self.drop.triggerEventIfEnabled('itemSelected', row.id);
            }
        });
    };

    DropDownMultiSelect.prototype.setValue = function (selection) {
        this.selection = selection;
        this.updateUi();
    };

    DropDownMultiSelect.prototype.updateUi = function () {
        if (!this.selection)
            return;

        var self = this;
        _.each(this.rows, function (row) {
            var selected = self.selection.indexOf(row.id) !== -1;
            if (selected)
                row.check();
            else
                row.uncheck();
        });
    };

    DropDownMultiSelect.prototype.updateSummary = function () {
        var selectNames = _.chain(this.rows)
            .where({ checked: true })
            .pluck('label')
            .value();
        var summary = selectNames.join(', ');

        this.togglePlaceholder(!summary);
        this.$label.text(summary);
    };

    DropDownMultiSelect.prototype.getValue = function () {
        return _.chain(this.rows)
            .where({ checked: true })
            .pluck('id')
            .value();
    };

    DropDownMultiSelect.prototype.togglePlaceholder = function (isVisible) {
        this.$placeholder.toggle(!!isVisible);
        this.$label.toggle(!isVisible);

        if (!!isVisible && this.drop.$element) {
            this.drop.$element.addClass('multiselect-dropdown-placeholder');
            this.drop.$element.addClass('empty');
        } else if (this.drop.$element) {
            this.drop.$element.removeClass('multiselect-dropdown-placeholder');
            this.drop.$element.removeClass('empty');
        }

        this.$el
            .append(this.$label, this.$buttonWrapper)
    };

    DropDownMultiSelect.prototype.dispose = function () {
        this.$list.remove();
        $(document).off('click', this.onClicked);
        this.drop.piping.$actionWrapper.off('scroll', this.onScrolled);
    };

    return DropDownMultiSelect;
});
